/**
 *  Hide an element if the organization is freemium.
 *  It can receive an application role using app-permission attribute and an application using application attribute,
 *  it will be used to check if the user has permission in that application to see the element
 */
;(function () {
  angular
    .module('contrast.freemium.directives')
    .directive(
      'freemiumHide',
      function (UserService, permissions, ORGANIZATION_SWITCH_EVENT) {
        'ngInject'

        return {
          link: function (scope, element, attrs) {
            var appRole = attrs.appPermission
            var application
            if (appRole) {
              if (!_.isString(attrs.application)) {
                // eslint-disable-next-line no-throw-literal
                throw 'application value must be a string'
              }
              application = attrs.application.trim()
            }

            function toggleVisibilityBasedOnFreemium() {
              var isFreemium = UserService.isFreemiumOrganization() || false
              var doesntHavePermission = angular.isDefined(appRole)
                ? !permissions.hasAppPermission(application, appRole)
                : false
              if (isFreemium || doesntHavePermission) {
                element.hide()
              } else {
                element.show()
              }
            }

            toggleVisibilityBasedOnFreemium()
            scope.$on(
              ORGANIZATION_SWITCH_EVENT,
              toggleVisibilityBasedOnFreemium
            )
          }
        }
      }
    )
})()
